import { matchPath } from 'react-router-dom';
import { ContextResolver } from '../types';

const OPPORTUNITY_BOARD_FILTER_KEYS = ['search', 'owner', 'score', 'stage', 'createdAt', 'amount', 'tags'];
const OPPORTUNITY_BOARD_ROUTE_PATTERN = '/:agentId/opportunities/:pipelineId/view/board';
const BOARD_CAPABILITIES = [
    'View all opportunities',
    'Create new opportunities',
    'Change opportunity stage',
    'Search and filter opportunities',
];
const OPPORTUNITY_DETAILS_CAPABILITIES = [
    'Review and update opportunity details',
    'Edit key opportunity attributes',
    'Record context and follow-up notes',
    'Organize and update opportunity TODOs',
];

const opportunitiesBoardResolver: ContextResolver = {
    match: ({ pathname }) => Boolean(matchPath(OPPORTUNITY_BOARD_ROUTE_PATTERN, pathname)),
    resolve: ({ pathname, searchParams }) => {
        const routeMatch = matchPath(OPPORTUNITY_BOARD_ROUTE_PATTERN, pathname);
        const pipelineId = routeMatch?.params?.pipelineId || '';
        const appliedFilters = OPPORTUNITY_BOARD_FILTER_KEYS.reduce((filters: string[], key) => {
            const value = searchParams.get(key);
            if (!value) {
                return filters;
            }
            return [...filters, `${key}: ${value}`];
        }, []);
        const opportunityId = searchParams.get('showOpportunity') || '';

        return {
            description: 'User is working in the opportunities board to review and manage pipeline opportunities.',
            capabilities: opportunityId ? OPPORTUNITY_DETAILS_CAPABILITIES : BOARD_CAPABILITIES,
            ids: {
                ...(pipelineId ? { pipelineId } : {}),
                ...(opportunityId ? { opportunityId } : {}),
            },
            hints: [
                'The user is viewing the opportunities board.',
                ...(pipelineId ? [`Pipeline ${pipelineId} is selected in this board view.`] : []),
                ...(opportunityId ? [`Opportunity ${opportunityId} is currently open in the details drawer.`] : []),
                ...(appliedFilters.length > 0
                    ? [`The board currently has active filters: ${appliedFilters.join(', ')}.`]
                    : ['No board filters are currently applied.']),
            ],
        };
    },
};

export default opportunitiesBoardResolver;
